import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { isIterableSet } from './is.utils.js';

function iterToSet(iterable) {
  return isIterableSet(iterable) ? iterable : new Set(iterable);
}

function mergeIterables() {
  var items = [];

  for (var _len = arguments.length, iterables = new Array(_len), _key = 0; _key < _len; _key++) {
    iterables[_key] = arguments[_key];
  }

  iterables.forEach(function (iterable) {
    if (iterable) {
      items.push.apply(items, _toConsumableArray(Array.from(iterable)));
    }
  });
  return new Set(items);
}

export { iterToSet, mergeIterables };